var map = {
  "./AI_16.svg": "4026",
  "./AI_24.svg": "24055",
  "./accounting_ledger_16.svg": "89009",
  "./accounting_ledger_24.svg": "33304",
  "./accounting_report_16.svg": "8200",
  "./accounting_report_24.svg": "55429",
  "./action_log_16.svg": "61109",
  "./action_log_24.svg": "14844",
  "./activity_report_16.svg": "77244",
  "./activity_report_24.svg": "32601",
  "./add_16.svg": "24901",
  "./add_24.svg": "15532",
  "./add_customer_16.svg": "98596",
  "./add_customer_24.svg": "28065",
  "./add_photo_16.svg": "24900",
  "./add_photo_24.svg": "54369",
  "./alert_circle_16.svg": "74197",
  "./alert_circle_24.svg": "74972",
  "./analytics_16.svg": "62492",
  "./analytics_24.svg": "76505",
  "./archive_16.svg": "89770",
  "./archive_24.svg": "52487",
  "./arrivals_16.svg": "77270",
  "./arrivals_24.svg": "1539",
  "./arrow_counter_clockwise_1_16.svg": "5557",
  "./arrow_counter_clockwise_1_24.svg": "59292",
  "./arrow_counter_clockwise_2_16.svg": "58642",
  "./arrow_counter_clockwise_2_24.svg": "15375",
  "./arrow_counter_clockwise_3_16.svg": "47",
  "./arrow_counter_clockwise_3_24.svg": "12958",
  "./arrow_counter_clockwise_4_16.svg": "50404",
  "./arrow_counter_clockwise_4_24.svg": "76353",
  "./arrow_counter_clockwise_5_16.svg": "53297",
  "./arrow_counter_clockwise_5_24.svg": "97592",
  "./arrow_counter_clockwise_6_16.svg": "50526",
  "./arrow_counter_clockwise_6_24.svg": "91851",
  "./arrow_counter_clockwise_7_16.svg": "81163",
  "./arrow_counter_clockwise_7_24.svg": "75146",
  "./arrow_counter_clockwise_8_16.svg": "21216",
  "./arrow_counter_clockwise_8_24.svg": "73021",
  "./arrow_counter_clockwise_9_16.svg": "83533",
  "./arrow_counter_clockwise_9_24.svg": "29684",
  "./arrow_counter_clockwise_9_plus_16.svg": "95168",
  "./arrow_counter_clockwise_9_plus_24.svg": "13309",
  "./arrow_down_16.svg": "59142",
  "./arrow_down_24.svg": "68723",
  "./arrow_joined_16.svg": "78557",
  "./arrow_joined_24.svg": "41892",
  "./arrow_left_16.svg": "30669",
  "./arrow_left_24.svg": "79092",
  "./arrow_right_16.svg": "66244",
  "./arrow_right_24.svg": "81345",
  "./arrow_up_16.svg": "6105",
  "./arrow_up_24.svg": "91328",
  "./assign_16.svg": "58415",
  "./assign_24.svg": "97726",
  "./at_mention_16.svg": "31100",
  "./at_mention_24.svg": "96793",
  "./availability_16.svg": "11137",
  "./availability_24.svg": "66280",
  "./available_dates_16.svg": "63147",
  "./available_dates_24.svg": "8573",
  "./baby_cot_16.svg": "99447",
  "./baby_cot_24.svg": "52678",
  "./backward_16.svg": "97947",
  "./backward_24.svg": "25978",
  "./backward_more_16.svg": "22205",
  "./backward_more_24.svg": "65572",
  "./bathroom_16.svg": "35322",
  "./bathroom_24.svg": "12791",
  "./bike_16.svg": "98515",
  "./bike_24.svg": "8658",
  "./bills_invoices_16.svg": "25669",
  "./bills_invoices_24.svg": "43596",
  "./birthday_16.svg": "2239",
  "./birthday_24.svg": "96142",
  "./blacklist_16.svg": "81581",
  "./blacklist_24.svg": "11476",
  "./bold_16.svg": "7017",
  "./bold_24.svg": "35184",
  "./breadcrumb_16.svg": "85979",
  "./breadcrumb_24.svg": "38330",
  "./briefcase_16.svg": "48704",
  "./briefcase_24.svg": "94717",
  "./broom_16.svg": "68519",
  "./broom_24.svg": "8502",
  "./building_plus_16.svg": "53555",
  "./building_plus_24.svg": "13298",
  "./bulb_stars_16.svg": "10455",
  "./bulb_stars_24.svg": "25062",
  "./bulk_edit_16.svg": "35915",
  "./bulk_edit_24.svg": "87370",
  "./bus_16.svg": "52422",
  "./bus_24.svg": "32307",
  "./calendar_16.svg": "6342",
  "./calendar_24.svg": "35155",
  "./calendar_day_16.svg": "29437",
  "./calendar_day_24.svg": "68612",
  "./calendar_month_16.svg": "357",
  "./calendar_month_24.svg": "18284",
  "./calendar_stars_16.svg": "64948",
  "./calendar_stars_24.svg": "8369",
  "./calendar_week_16.svg": "23949",
  "./calendar_week_24.svg": "53844",
  "./call_16.svg": "32320",
  "./call_24.svg": "84125",
  "./camera_16.svg": "21269",
  "./camera_24.svg": "75004",
  "./camping_pitch_16.svg": "38254",
  "./camping_pitch_24.svg": "12315",
  "./cancel_square_16.svg": "33888",
  "./cancel_square_24.svg": "68381",
  "./caravan_16.svg": "66090",
  "./caravan_24.svg": "45159",
  "./card_check_16.svg": "55691",
  "./card_check_24.svg": "49674",
  "./card_keys_16.svg": "85129",
  "./card_keys_24.svg": "95152",
  "./card_nfc_16.svg": "35236",
  "./card_nfc_24.svg": "64705",
  "./caret_filled_down_16.svg": "97039",
  "./caret_filled_down_24.svg": "26302",
  "./caret_filled_up_16.svg": "88148",
  "./caret_filled_up_24.svg": "34257",
  "./cash_payment_16.svg": "74470",
  "./cash_payment_24.svg": "88179",
  "./cashier_16.svg": "76871",
  "./cashier_24.svg": "2902",
  "./cashlist_16.svg": "60085",
  "./cashlist_24.svg": "13820",
  "./channel_manager_16.svg": "62553",
  "./channel_manager_24.svg": "47776",
  "./charge_16.svg": "11284",
  "./charge_24.svg": "57393",
  "./chargeable_16.svg": "82768",
  "./chargeable_24.svg": "58765",
  "./chargeback_16.svg": "8549",
  "./chargeback_24.svg": "99180",
  "./checkbox_empty_16.svg": "76565",
  "./checkbox_empty_24.svg": "77340",
  "./checkbox_minus_16.svg": "53154",
  "./checkbox_plus_16.svg": "57818",
  "./checkbox_tick_16.svg": "17057",
  "./checkbox_tick_24.svg": "36424",
  "./checked_in_16.svg": "38727",
  "./checked_in_24.svg": "69654",
  "./checked_out_16.svg": "59858",
  "./checked_out_24.svg": "16591",
  "./checkin_16.svg": "68673",
  "./checkin_24.svg": "29640",
  "./checkout_16.svg": "55536",
  "./checkout_24.svg": "31533",
  "./chevron_down_16.svg": "11728",
  "./chevron_down_24.svg": "32845",
  "./chevron_left_16.svg": "37407",
  "./chevron_left_24.svg": "13646",
  "./chevron_right_16.svg": "8542",
  "./chevron_right_24.svg": "34123",
  "./chevron_up_16.svg": "36383",
  "./chevron_up_24.svg": "12622",
  "./child_head_16.svg": "5887",
  "./child_head_24.svg": "99790",
  "./city_16.svg": "28217",
  "./city_24.svg": "29792",
  "./clear_selection_16.svg": "86132",
  "./clear_selection_24.svg": "32241",
  "./collapse_16.svg": "21473",
  "./collapse_24.svg": "40840",
  "./collapse_all_16.svg": "33409",
  "./collapse_all_24.svg": "52776",
  "./companies_16.svg": "90297",
  "./companies_24.svg": "75520",
  "./complaint_16.svg": "69503",
  "./complaint_24.svg": "45742",
  "./configuration_16.svg": "44466",
  "./configuration_24.svg": "1199",
  "./connect_16.svg": "88922",
  "./connect_24.svg": "50039",
  "./copy_16.svg": "38579",
  "./copy_24.svg": "12946",
  "./countries_16.svg": "61294",
  "./countries_24.svg": "11835",
  "./covid_protection_16.svg": "93043",
  "./covid_protection_24.svg": "3186",
  "./credit_card_file_16.svg": "28113",
  "./credit_card_file_24.svg": "99832",
  "./credit_card_report_16.svg": "62721",
  "./credit_card_report_24.svg": "23688",
  "./crib_16.svg": "18678",
  "./crib_24.svg": "85424",
  "./cross_close_16.svg": "54009",
  "./cross_close_24.svg": "38944",
  "./cultures_16.svg": "75917",
  "./cultures_24.svg": "24340",
  "./currency_switch_16.svg": "39532",
  "./currency_switch_24.svg": "6729",
  "./custom_link_16.svg": "89436",
  "./custom_link_24.svg": "17977",
  "./custom_link_item_16.svg": "96250",
  "./custom_link_item_24.svg": "16279",
  "./customer_profiles_16.svg": "69773",
  "./customer_profiles_24.svg": "34548",
  "./customer_success_16.svg": "59916",
  "./customer_success_24.svg": "27113",
  "./dashboard_16.svg": "58804",
  "./dashboard_24.svg": "2225",
  "./delete_16.svg": "65673",
  "./delete_24.svg": "77488",
  "./departures_16.svg": "20959",
  "./departures_24.svg": "13870",
  "./deployments_16.svg": "84848",
  "./deployments_24.svg": "22317",
  "./desk_16.svg": "52447",
  "./desk_24.svg": "46350",
  "./device_command_16.svg": "87160",
  "./device_command_24.svg": "27938",
  "./disability_16.svg": "34334",
  "./disability_24.svg": "59915",
  "./disable_16.svg": "37276",
  "./disable_24.svg": "2969",
  "./dollar_arrow_down_16.svg": "32195",
  "./dollar_arrow_down_24.svg": "44322",
  "./done_16.svg": "39852",
  "./done_24.svg": "77353",
  "./done_circle_16.svg": "85251",
  "./done_circle_24.svg": "23042",
  "./door_hanger_16.svg": "27438",
  "./door_hanger_24.svg": "23880",
  "./double_bed_16.svg": "14259",
  "./double_bed_24.svg": "90354",
  "./download_16.svg": "20428",
  "./download_24.svg": "87625",
  "./draggable_16.svg": "82133",
  "./draggable_24.svg": "19516",
  "./driving_licence_16.svg": "12369",
  "./driving_licence_24.svg": "83672",
  "./edit_16.svg": "93984",
  "./edit_24.svg": "39997",
  "./education_16.svg": "55642",
  "./education_24.svg": "91671",
  "./email_queue_16.svg": "30636",
  "./email_queue_24.svg": "84489",
  "./email_queues_16.svg": "81127",
  "./email_queues_24.svg": "12054",
  "./employees_16.svg": "53179",
  "./employees_24.svg": "81210",
  "./enterprise_snapshot_16.svg": "11056",
  "./enterprise_snapshot_24.svg": "84173",
  "./error_circle_16.svg": "9689",
  "./error_circle_24.svg": "94624",
  "./execute_16.svg": "40725",
  "./execute_24.svg": "94460",
  "./execute_merchant_16.svg": "86496",
  "./execute_merchant_24.svg": "23965",
  "./expand_16.svg": "78728",
  "./expand_24.svg": "70149",
  "./expand_all_16.svg": "23416",
  "./expand_all_24.svg": "99221",
  "./experiences_16.svg": "25431",
  "./experiences_24.svg": "62310",
  "./export_schedule_16.svg": "67990",
  "./export_schedule_24.svg": "80771",
  "./exports_16.svg": "61549",
  "./exports_24.svg": "26324",
  "./external_link_16.svg": "7684",
  "./external_link_24.svg": "2465",
  "./external_payment_16.svg": "67010",
  "./external_payment_24.svg": "68895",
  "./extrabed_16.svg": "70515",
  "./extrabed_24.svg": "30258",
  "./face_happy_16.svg": "31420",
  "./face_happy_24.svg": "97113",
  "./face_id_16.svg": "82074",
  "./face_id_24.svg": "28852",
  "./face_sad_16.svg": "7354",
  "./face_sad_24.svg": "27031",
  "./facebook_16.svg": "94000",
  "./facebook_24.svg": "67117",
  "./fast_backward_simple_16.svg": "56095",
  "./fast_backward_simple_24.svg": "49998",
  "./fast_forward_simple_16.svg": "48657",
  "./fast_forward_simple_24.svg": "92952",
  "./features_16.svg": "60937",
  "./features_24.svg": "77840",
  "./female_16.svg": "40624",
  "./female_24.svg": "96397",
  "./file_check_16.svg": "13167",
  "./file_check_24.svg": "26078",
  "./filter_16.svg": "56430",
  "./filter_24.svg": "82075",
  "./finance_16.svg": "92054",
  "./finance_24.svg": "63843",
  "./fiscal_report_16.svg": "8943",
  "./fiscal_report_24.svg": "31902",
  "./floppy_disc_16.svg": "8170",
  "./floppy_disc_24.svg": "93927",
  "./folder_closed_16.svg": "98991",
  "./folder_closed_24.svg": "38302",
  "./folder_opened_16.svg": "92900",
  "./folder_opened_24.svg": "18849",
  "./food_16.svg": "78327",
  "./food_24.svg": "30177",
  "./forum_outline_16.svg": "20564",
  "./forum_outline_24.svg": "63985",
  "./forward_16.svg": "25763",
  "./forward_24.svg": "63554",
  "./forward_more_16.svg": "78949",
  "./forward_more_24.svg": "80524",
  "./free_16.svg": "20106",
  "./free_24.svg": "5863",
  "./friend_family_16.svg": "19663",
  "./friend_family_24.svg": "32574",
  "./ftp_16.svg": "86298",
  "./ftp_24.svg": "63767",
  "./gateway_payments_16.svg": "37956",
  "./gateway_payments_24.svg": "86286",
  "./gift_16.svg": "58138",
  "./gift_24.svg": "19255",
  "./guest_in_house_16.svg": "91119",
  "./guest_in_house_24.svg": "80126",
  "./guides_16.svg": "11431",
  "./guides_24.svg": "45110",
  "./help_16.svg": "91473",
  "./help_24.svg": "62776",
  "./help_center_16.svg": "85735",
  "./help_center_24.svg": "16662",
  "./hide_16.svg": "73012",
  "./hide_24.svg": "58641",
  "./home_16.svg": "41441",
  "./home_24.svg": "86056",
  "./home_empty_16.svg": "42103",
  "./home_empty_24.svg": "21350",
  "./hourglass_16.svg": "74134",
  "./hourglass_24.svg": "86915",
  "./house_use_16.svg": "12416",
  "./house_use_24.svg": "64221",
  "./id_card_16.svg": "43128",
  "./id_card_24.svg": "45173",
  "./import_16.svg": "66611",
  "./import_24.svg": "76754",
  "./import_customers_16.svg": "94525",
  "./import_customers_24.svg": "21540",
  "./important_16.svg": "61170",
  "./important_24.svg": "51631",
  "./imports_16.svg": "62374",
  "./imports_24.svg": "59731",
  "./improvement_16.svg": "70500",
  "./improvement_24.svg": "65281",
  "./info_16.svg": "75636",
  "./info_24.svg": "19057",
  "./installations_16.svg": "39183",
  "./installations_24.svg": "52094",
  "./integration_partners_16.svg": "52188",
  "./integration_partners_24.svg": "7545",
  "./integrations_16.svg": "87881",
  "./integrations_24.svg": "16048",
  "./inventory_updates_16.svg": "29951",
  "./inventory_updates_24.svg": "89838",
  "./italic_16.svg": "82704",
  "./italic_24.svg": "22125",
  "./items_16.svg": "94200",
  "./items_24.svg": "67861",
  "./jobs_16.svg": "86732",
  "./jobs_24.svg": "40585",
  "./key_16.svg": "32157",
  "./key_24.svg": "79140",
  "./language_switch_16.svg": "32989",
  "./language_switch_24.svg": "88516",
  "./languages_16.svg": "31973",
  "./languages_24.svg": "22604",
  "./layout_grid_16.svg": "96785",
  "./layout_grid_24.svg": "6936",
  "./legal_environments_16.svg": "36612",
  "./legal_environments_24.svg": "31393",
  "./lightning_bolt_16.svg": "60792",
  "./lightning_bolt_24.svg": "18101",
  "./linkedin_16.svg": "3306",
  "./linkedin_24.svg": "82375",
  "./list_ordered_16.svg": "7950",
  "./list_ordered_24.svg": "33595",
  "./location_16.svg": "38349",
  "./location_24.svg": "84596",
  "./lock_16.svg": "84473",
  "./lock_24.svg": "69696",
  "./logout_16.svg": "83886",
  "./logout_24.svg": "9531",
  "./loyalty_16.svg": "55658",
  "./loyalty_24.svg": "41415",
  "./luggage_16.svg": "74996",
  "./luggage_24.svg": "60625",
  "./magic_16.svg": "9093",
  "./magic_24.svg": "37836",
  "./mails_16.svg": "8824",
  "./mails_24.svg": "83253",
  "./make_default_16.svg": "31792",
  "./make_default_24.svg": "69261",
  "./male_16.svg": "7659",
  "./male_24.svg": "59114",
  "./manager_report_16.svg": "29074",
  "./manager_report_24.svg": "48143",
  "./mark_as_read_16.svg": "59589",
  "./mark_as_read_24.svg": "61164",
  "./marketplace_16.svg": "68177",
  "./marketplace_24.svg": "39896",
  "./media_16.svg": "91220",
  "./media_24.svg": "95089",
  "./media_playback_pause_16.svg": "78099",
  "./media_playback_pause_24.svg": "52466",
  "./media_playback_play_16.svg": "3041",
  "./media_playback_play_24.svg": "8808",
  "./megaphone_16.svg": "81634",
  "./megaphone_24.svg": "83519",
  "./menu_16.svg": "19393",
  "./menu_24.svg": "80360",
  "./menu_arrow_left_16.svg": "87657",
  "./menu_arrow_left_24.svg": "14032",
  "./menu_arrow_right_16.svg": "46840",
  "./menu_arrow_right_24.svg": "48885",
  "./merchant_16.svg": "49064",
  "./merchant_24.svg": "54597",
  "./message_16.svg": "34373",
  "./message_24.svg": "63116",
  "./messages_plural_16.svg": "22325",
  "./messages_plural_24.svg": "66812",
  "./mews_logo_16.svg": "13282",
  "./mews_logo_24.svg": "64415",
  "./microphone_16.svg": "53256",
  "./microphone_24.svg": "44677",
  "./military_16.svg": "44698",
  "./military_24.svg": "70740",
  "./minus_16.svg": "52072",
  "./minus_24.svg": "15653",
  "./minus_simple_16.svg": "81405",
  "./minus_simple_24.svg": "8420",
  "./more_16.svg": "91735",
  "./more_24.svg": "70982",
  "./move_16.svg": "3419",
  "./move_24.svg": "31450",
  "./move_payment_16.svg": "51968",
  "./move_payment_24.svg": "73085",
  "./move_payment_horizontal_16.svg": "70524",
  "./move_payment_horizontal_24.svg": "37150",
  "./nonbreaking_space_16.svg": "20713",
  "./nonbreaking_space_24.svg": "53968",
  "./notes_16.svg": "15547",
  "./notes_24.svg": "39802",
  "./notifications_16.svg": "35024",
  "./notifications_24.svg": "90797",
  "./occupancy_16.svg": "99347",
  "./occupancy_24.svg": "9490",
  "./operations_16.svg": "12838",
  "./operations_24.svg": "41651",
  "./out_of_order_16.svg": "44289",
  "./out_of_order_24.svg": "33704",
  "./paperclip_16.svg": "34908",
  "./paperclip_24.svg": "601",
  "./passport_16.svg": "44622",
  "./passport_24.svg": "53915",
  "./past_shifts_16.svg": "63668",
  "./past_shifts_24.svg": "71678",
  "./paymaster_16.svg": "17188",
  "./paymaster_24.svg": "46657",
  "./payment_attempts_16.svg": "96515",
  "./payment_attempts_24.svg": "65250",
  "./payment_card_16.svg": "96091",
  "./payment_card_24.svg": "91546",
  "./payment_report_16.svg": "74479",
  "./payment_report_24.svg": "97438",
  "./payment_request_16.svg": "91364",
  "./payment_request_24.svg": "6465",
  "./payments_16.svg": "40309",
  "./payments_24.svg": "24732",
  "./phone_16.svg": "78500",
  "./phone_24.svg": "4449",
  "./photo_expand_16.svg": "95363",
  "./photo_expand_24.svg": "91138",
  "./pin_16.svg": "67437",
  "./pin_24.svg": "97332",
  "./places_16.svg": "54492",
  "./places_24.svg": "83033",
  "./places_pin_16.svg": "43328",
  "./places_pin_24.svg": "89341",
  "./plane_16.svg": "59782",
  "./plane_24.svg": "56019",
  "./platform_migrations_16.svg": "57047",
  "./platform_migrations_24.svg": "11398",
  "./plus_16.svg": "57216",
  "./plus_24.svg": "3229",
  "./plus_simple_16.svg": "6885",
  "./plus_simple_24.svg": "75135",
  "./posting_journal_16.svg": "2958",
  "./posting_journal_24.svg": "37147",
  "./power_bi_16.svg": "43445",
  "./power_bi_24.svg": "94908",
  "./preauthorization_16.svg": "47718",
  "./preauthorization_24.svg": "76531",
  "./pricing_16.svg": "78798",
  "./pricing_24.svg": "29339",
  "./print_16.svg": "22249",
  "./print_24.svg": "39152",
  "./print_pdf_16.svg": "21270",
  "./print_pdf_24.svg": "34051",
  "./problematic_16.svg": "99190",
  "./problematic_24.svg": "87331",
  "./product_16.svg": "32749",
  "./product_24.svg": "18260",
  "./product_report_16.svg": "3258",
  "./product_report_24.svg": "50711",
  "./profile_16.svg": "49379",
  "./profile_24.svg": "18114",
  "./profiles_16.svg": "71254",
  "./profiles_24.svg": "43043",
  "./property_16.svg": "76731",
  "./property_24.svg": "17338",
  "./queues_16.svg": "17284",
  "./queues_24.svg": "12065",
  "./quote_16.svg": "28640",
  "./quote_24.svg": "49757",
  "./radio_empty_16.svg": "88819",
  "./radio_empty_24.svg": "48562",
  "./radio_selected_16.svg": "58543",
  "./radio_selected_24.svg": "31198",
  "./rate_management_16.svg": "90552",
  "./rate_management_24.svg": "64213",
  "./rebate_16.svg": "40105",
  "./rebate_24.svg": "80432",
  "./refresh_16.svg": "21245",
  "./refresh_24.svg": "84580",
  "./refund_16.svg": "44474",
  "./refund_24.svg": "14308",
  "./report_bug_16.svg": "44417",
  "./report_bug_24.svg": "50184",
  "./reservation_group_16.svg": "63530",
  "./reservation_group_24.svg": "42599",
  "./reservation_overview_16.svg": "57720",
  "./reservation_overview_24.svg": "32149",
  "./reservation_preview_16.svg": "67407",
  "./reservation_preview_24.svg": "13918",
  "./reservation_properties_16.svg": "7290",
  "./reservation_properties_24.svg": "54743",
  "./reservation_report_16.svg": "747",
  "./reservation_report_24.svg": "97866",
  "./reservations_16.svg": "65809",
  "./reservations_24.svg": "75960",
  "./reset_16.svg": "99809",
  "./reset_24.svg": "89224",
  "./restore_16.svg": "49178",
  "./restore_24.svg": "96631",
  "./restriction_16.svg": "75926",
  "./restriction_24.svg": "195",
  "./return_16.svg": "83470",
  "./return_24.svg": "10363",
  "./returning_16.svg": "74102",
  "./returning_24.svg": "86883",
  "./room_16.svg": "13869",
  "./room_24.svg": "99380",
  "./scan_id_16.svg": "24001",
  "./scan_id_24.svg": "84968",
  "./scan_qr_16.svg": "50423",
  "./scan_qr_24.svg": "29670",
  "./scanner_16.svg": "52082",
  "./scanner_24.svg": "14895",
  "./schedules_16.svg": "49054",
  "./schedules_24.svg": "17259",
  "./search_16.svg": "17892",
  "./search_24.svg": "47361",
  "./security_16.svg": "39446",
  "./security_24.svg": "163",
  "./send_message_16.svg": "87214",
  "./send_message_24.svg": "14107",
  "./service_order_16.svg": "52028",
  "./service_order_24.svg": "17721",
  "./services_16.svg": "96656",
  "./services_24.svg": "34125",
  "./settings_16.svg": "66651",
  "./settings_24.svg": "94682",
  "./settings_user_16.svg": "31799",
  "./settings_user_24.svg": "11046",
  "./share_16.svg": "70397",
  "./share_24.svg": "13764",
  "./shared_data_16.svg": "26797",
  "./shared_data_24.svg": "69207",
  "./show_16.svg": "52675",
  "./show_24.svg": "21922",
  "./shrink_16.svg": "93215",
  "./shrink_24.svg": "6894",
  "./space_status_16.svg": "31223",
  "./space_status_24.svg": "85574",
  "./special_character_16.svg": "1281",
  "./special_character_24.svg": "90696",
  "./spent_nights_16.svg": "32746",
  "./spent_nights_24.svg": "11815",
  "./spinner_16.svg": "38127",
  "./spinner_24.svg": "61086",
  "./split_16.svg": "41916",
  "./split_24.svg": "97273",
  "./staff_16.svg": "39010",
  "./staff_24.svg": "40895",
  "./star_filled_16.svg": "48611",
  "./star_filled_24.svg": "2754",
  "./stars_16.svg": "8623",
  "./stars_24.svg": "81278",
  "./statistics_16.svg": "37673",
  "./statistics_24.svg": "94352",
  "./stayovers_16.svg": "73052",
  "./stayovers_24.svg": "85241",
  "./strikethrough_16.svg": "71597",
  "./strikethrough_24.svg": "1492",
  "./subscription_16.svg": "24755",
  "./subscription_24.svg": "850",
  "./summary_16.svg": "9128",
  "./summary_24.svg": "56357",
  "./summary_order_16.svg": "41345",
  "./summary_order_24.svg": "47112",
  "./switch_video_16.svg": "22572",
  "./switch_video_24.svg": "93641",
  "./targets_16.svg": "52274",
  "./targets_24.svg": "25359",
  "./tasks_16.svg": "40886",
  "./tasks_24.svg": "53667",
  "./tax_environment_16.svg": "10481",
  "./tax_environment_24.svg": "82200",
  "./team_area_16.svg": "20449",
  "./team_area_24.svg": "39816",
  "./tent_16.svg": "80091",
  "./tent_24.svg": "75546",
  "./terminal_16.svg": "99028",
  "./terminal_24.svg": "1009",
  "./terminal_payment_16.svg": "35599",
  "./terminal_payment_24.svg": "48510",
  "./text_align_center_16.svg": "24353",
  "./text_align_center_24.svg": "68968",
  "./text_align_justify_16.svg": "87558",
  "./text_align_justify_24.svg": "97139",
  "./text_align_left_16.svg": "89401",
  "./text_align_left_24.svg": "74624",
  "./text_align_right_16.svg": "81928",
  "./text_align_right_24.svg": "89317",
  "./text_line_height_16.svg": "45812",
  "./text_line_height_24.svg": "49681",
  "./thumbs_down_16.svg": "59970",
  "./thumbs_down_24.svg": "11103",
  "./thumbs_up_16.svg": "85949",
  "./thumbs_up_24.svg": "49284",
  "./time_16.svg": "18591",
  "./time_24.svg": "48622",
  "./timeline_16.svg": "32765",
  "./timeline_24.svg": "96100",
  "./timeline_compact_16.svg": "69171",
  "./timeline_compact_24.svg": "79314",
  "./timeline_dense_16.svg": "11525",
  "./timeline_dense_24.svg": "96428",
  "./timeline_spacious_16.svg": "38925",
  "./timeline_spacious_24.svg": "24436",
  "./toggle_left_16.svg": "69312",
  "./toggle_left_24.svg": "87453",
  "./toggle_right_16.svg": "4263",
  "./toggle_right_24.svg": "30294",
  "./top_management_16.svg": "16019",
  "./top_management_24.svg": "10336",
  "./train_16.svg": "68994",
  "./train_24.svg": "20127",
  "./travel_agency_16.svg": "67046",
  "./travel_agency_24.svg": "76627",
  "./travel_club_16.svg": "44111",
  "./travel_club_24.svg": "67070",
  "./travel_visa_16.svg": "42544",
  "./travel_visa_24.svg": "15661",
  "./tripadvisor_16.svg": "59011",
  "./tripadvisor_24.svg": "13154",
  "./twitter_16.svg": "25601",
  "./twitter_24.svg": "15016",
  "./underline_16.svg": "29904",
  "./underline_24.svg": "67373",
  "./unlock_16.svg": "35752",
  "./unlock_24.svg": "41285",
  "./upgraded_16.svg": "19140",
  "./upgraded_24.svg": "30273",
  "./upload_16.svg": "83379",
  "./upload_24.svg": "43122",
  "./user_card_stack_16.svg": "1135",
  "./user_card_stack_24.svg": "30398",
  "./user_clock_16.svg": "83650",
  "./user_clock_24.svg": "51135",
  "./user_refresh_16.svg": "65617",
  "./user_refresh_24.svg": "53387",
  "./very_important_16.svg": "53143",
  "./very_important_24.svg": "90022",
  "./view_off_16.svg": "21181",
  "./view_off_24.svg": "48196",
  "./view_report_16.svg": "89320",
  "./view_report_24.svg": "94853",
  "./website_16.svg": "24611",
  "./website_24.svg": "62402",
  "./wellness_16.svg": "29441",
  "./wellness_24.svg": "35208",
  "./window_16.svg": "78688",
  "./window_24.svg": "96829"
};


function webpackAsyncContext(req) {
  return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
  return __webpack_require__.e(/* lazy-once context | icons */ "896").then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }
    return map[req];
  })
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 10840;
module.exports = webpackAsyncContext;
